@if (booking?.booking?.task_list?.id) {
  <tidy-row class="extra-top-margin">
    <tidy-text
      [header]="'Checklist Updates'" />
  </tidy-row>
  @if (!isToDosLoaded) {
    <tidy-card>
      <tidy-row>
        <ion-skeleton-text animated style="width: 85%; height: 14px; border-radius: 6px;" />
      </tidy-row>
    </tidy-card>
  }
  @if (!didProStartToDos && isToDosLoaded) {
    <tidy-card>
      <tidy-row>
        <tidy-text
          [helper]="'Checklist and photos will appear here as '" />
        <tidy-text
          [helper]="booking?.booking?.current_job?.homekeepers?.[0]?.first_name ? ((booking?.booking?.current_job?.homekeepers?.[0]?.first_name | titlecase | translate)) : 'the pro'" />
        @if (booking?.booking?.current_job?.homekeepers?.[1]) {
          <tidy-text
            [helper]="' and '" />
          <tidy-text
            [helper]="booking?.booking?.current_job?.homekeepers?.[1]?.first_name | titlecase" />
        }
        <tidy-text
          [helper]="booking?.booking?.current_job?.homekeepers?.[1] ? ' update them.' : ' updates them.'" />
      </tidy-row>
    </tidy-card>
  }
}

@if (didProStartToDos) {
  <tidy-row>
    <tidy-text
      [helper]="booking?.booking?.current_job?.homekeepers?.[0]?.first_name | titlecase" />
    @if (booking?.booking?.current_job?.homekeepers?.[1]) {
      <tidy-text
        [helper]="' and '" />
      <tidy-text
        [helper]="booking?.booking?.current_job?.homekeepers?.[1]?.first_name | titlecase" />
    }
    <tidy-text
      [helper]="(booking?.booking?.current_job?.homekeepers?.[1] ? (' are ' | translate) : (' is ' | translate)) + (' working on your checklist now:' | translate)" />
  </tidy-row>
  <tidy-card>
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
        <tidy-image
          [src]="'assets/img/camera.svg'"
          class="header-size" />
        <tidy-text
          [header]="'Before Photos / Videos'" />
      </div>
    </div>
    <div style="margin-top: 10px; display: flex; align-items: center; align-items: center;">
      @if (isNativeMobile) {
        <tidy-text
          [actionBody]="'Take Photo'"
          (action)="takePhoto('before_job')"
          class="white-link"
          style="margin-right: 10px" />
      }
      <tidy-file-upload
        [accept]="'image/*'"
        [showPreview]="false"
        [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
        (addedImagesChange)="uploadPhoto($event, 'before_job')"
        [showTextLink]="true"
        [textLinkClass]="'white-link'"
        style="margin-right: 10px" />
      @if (isNativeMobile) {
        <tidy-text
          [actionBody]="'Take Video'"
          (action)="takeVideo('before_job')"
          class="white-link"
          style="margin-right: 10px" />
      }
      <tidy-file-upload
        [accept]="'video/mp4'"
        [showPreview]="false"
        [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
        (addedImagesChange)="uploadVideo($event, 'before_job')"
        [showTextLink]="true"
        [textLinkClass]="'white-link'" />
    </div>
    @if (beforePhotos?.length == 0) {
      <tidy-row class="extra-top-padding">
        <tidy-text
          [helper]="'None Added'" /><span>&nbsp;</span>
        <tidy-text
          [helper]="beforeAfterState.before" />
      </tidy-row>
    }
    <ion-row>
      @for (item of beforePhotos; track item; let i = $index) {
        <ion-col [size]="12">
          @if (item.mediaType === 'video') {
            <tidy-row>
              <tidy-video
                class="before-after-video"
                [src]="item?.url"
                style="width: 100%; height: auto; max-width: 100%;" />
            </tidy-row>
          }
          @if (item.mediaType === 'photo') {
            @if (item?.url) {
              <tidy-photo-note
                class="full-width no-margin photo-note-job"
                [src]="item?.url"
                style="width: 100%; height: auto; max-width: 100%;" />
            }
          }
          @if (item?.metadata || item?.uploaded_by_id) {
            <div class="timestamp-caption">
              <tidy-row [alignLastItemRight]="true">
                <tidy-text
                  [smallBody]="'Uploaded By:'"
                  class="white" /><span>&nbsp;</span>
                <tidy-text
                  [smallBody]="item?.uploaded_by_type == 'CustomerMember' ? 'You' : 'Pro'"
                  class="white" />
                <div>
                  <tidy-image
                    [src]="'assets/img/trash-outline-white.svg'"
                    (action)="removePhoto(item, i, 'before_job')"
                    class="body-size"
                    style="cursor: pointer" />
                </div>
              </tidy-row>
              @if (item?.metadata?.location) {
                <tidy-row>
                  <tidy-text
                    [smallBody]="'Location:'"
                    class="white" /><span>&nbsp;</span>
                  <tidy-text
                    [smallBody]="item?.metadata?.location"
                    class="white" />
                </tidy-row>
              }
              @if (item?.metadata?.displayDate) {
                <tidy-row>
                  <tidy-text
                    [smallBody]="'Timestamp:'"
                    class="white" /><span>&nbsp;</span>
                  <tidy-text
                    [smallBody]="(item?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (item?.metadata?.displayDate | parseDateTime: 'h:mma')"
                    class="white" />
                </tidy-row>
              }
            </div>
          }
        </ion-col>
      }
    </ion-row>
  </tidy-card>

  @for (room of rooms; track room) {
    <tidy-card>
      <tidy-row class="vertical-align-center extra-bottom-padding">
        @if (room?.icon) {
          <tidy-image
            [src]="'assets/img/icons/rooms/' + room?.icon + '.svg'"
            class="header-size" />
        }
        <tidy-text
          [header]="room?.name"
          [translate]="false" />
      </tidy-row>
      <!--To-Dos for an ongoing job:-->
      @for (toDo of room?.todos; track toDo; let lastToDo = $last) {
        @if (toDo?.title !== 'Take Before Photo' && toDo?.title !== 'Take After Photo' && toDo?.title !== 'Take Before Video' && toDo?.title !== 'Take After Video') {
          <tidy-row class="extra-bottom-padding" [ngClass]="!lastToDo ? 'extra-bottom-padding vertical-align-middle' : 'vertical-align-middle'">
            <tidy-image
              [matTooltip]="toDo.toDoTooltip | translate"
              [src]="toDo.toDoIcon"
              class="body-size" />
            <tidy-text
              [body]="toDo?.title"
              [translate]="false" />
          </tidy-row>
        }
        @for (option of toDo?.options; track option; let last = $last) {
          @if (option?.value_type !== 'photo' && option?.value_type !== 'photos') {
            <tidy-row [ngClass]="(!last && !lastToDo) ? 'extra-bottom-padding' : ''">
              @if (option?.notes && (option?.json_value || option?.value)) {
                <tidy-text
                  [body]="option?.name + ': ' + option?.notes"
                  [translate]="false" /><br>
                <tidy-text
                  [body]="'Input: ' + (option?.json_value || option?.value)"
                  [translate]="false" />
              }
              @if (!option?.notes && (option?.json_value || option?.value)) {
                <tidy-text
                  [body]="option?.name"
                  [translate]="false" /><br>
                <tidy-text
                  [body]="'Input:'"
                  [translate]="false" /><span>&nbsp;</span>
                <tidy-text
                  [body]="option?.json_value || option?.value"
                  [translate]="false" />
              }
              @if (option?.notes && !option?.value && !option?.json_value) {
                <tidy-text
                  [body]="option?.name + ': ' + option?.notes"
                  [translate]="false" /><br>
                <tidy-text
                  [helper]="'No value added by pro'"
                  [translate]="false" />
              }
              @if (!option?.notes && !option?.value && !option?.json_value) {
                <tidy-text
                  [body]="option?.name"
                  [translate]="false" /><br>
                <tidy-text
                  [helper]="'No value added by pro'"
                  [translate]="false" />
              }
            </tidy-row>
          }
          @if (option?.value_type?.includes('photo')) {
            <tidy-row [ngClass]="(!last && !lastToDo) ? 'extra-bottom-padding' : ''">
              @if (option?.notes) {
                <tidy-text
                  [body]="option?.name + ': ' + option?.notes"
                  [translate]="false" />
              }
              @if (!option?.notes) {
                <tidy-text
                  [body]="option?.name"
                  [translate]="false" />
              }
              @if (option?.value) {
                <tidy-photo-note
                  class="full-width no-margin photo-note-job"
                  [src]="option?.value" />
              }
              @if (option?.metadata) {
                <div>
                  <tidy-row>
                    @if (option?.metadata?.location) {
                      <div class="timestamp-caption">
                        <tidy-text
                          [smallBody]="'Location:'"
                          class="white" /><span>&nbsp;</span>
                        <tidy-text
                          [smallBody]="option?.metadata?.location"
                          class="white" />
                      </div>
                    }
                    @if (option?.metadata?.displayDate) {
                      <div class="timestamp-caption">
                        <tidy-text
                          [smallBody]="'Timestamp:'"
                          class="white" /><span>&nbsp;</span>
                        <tidy-text
                          [smallBody]="(option?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (option?.metadata?.displayDate | parseDateTime: 'h:mma')"
                          class="white" />
                      </div>
                    }
                  </tidy-row>
                </div>
              }
              @for (option of option?.json_value; track option) {
                @if (option) {
                  <tidy-photo-note
                    class="full-width no-margin photo-note-job"
                    [src]="option" />
                }
                @if (option?.metadata) {
                  <div>
                    <tidy-row>
                      @if (option?.metadata?.location) {
                        <div class="timestamp-caption">
                          <tidy-text
                            [smallBody]="'Location:'"
                            class="white" /><span>&nbsp;</span>
                          <tidy-text
                            [smallBody]="option?.metadata?.location"
                            class="white" />
                        </div>
                      }
                      @if (option?.metadata?.displayDate) {
                        <div class="timestamp-caption">
                          <tidy-text
                            [smallBody]="'Timestamp:'"
                            class="white" /><span>&nbsp;</span>
                          <tidy-text
                            [smallBody]="(option?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (option?.metadata?.displayDate | parseDateTime: 'h:mma')"
                            class="white" />
                        </div>
                      }
                    </tidy-row>
                  </div>
                }
              }
              @if (!option?.value && !option?.json_value) {
                <br>
                <tidy-text
                  [helper]="'No photo taken by pro'" />
              }
            </tidy-row>
          }
        }
      }
    </tidy-card>
  }

  <tidy-card>
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
        <tidy-image
          [src]="'assets/img/camera.svg'"
          class="header-size" />
        <tidy-text
          [header]="'After Photos / Videos'" />
      </div>
    </div>
    <div style="margin-top: 10px; display: flex; align-items: center; align-items: center;">
      @if (isNativeMobile) {
        <tidy-text
          [actionBody]="'Take Photo'"
          (action)="takePhoto('after_job')"
          class="white-link"
          style="margin-right: 10px" />
      }
      <tidy-file-upload
        [accept]="'image/*'"
        [showPreview]="false"
        [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
        (addedImagesChange)="uploadPhoto($event, 'after_job')"
        [showTextLink]="true"
        [textLinkClass]="'white-link'"
        style="margin-right: 10px" />
      @if (isNativeMobile) {
        <tidy-text
          [actionBody]="'Take Video'"
          (action)="takeVideo('after_job')"
          class="white-link"
          style="margin-right: 10px" />
      }
      <tidy-file-upload
        [accept]="'video/mp4'"
        [showPreview]="false"
        [label]="isNativeMobile ? 'Upload Video' : 'Add Video'"
        (addedImagesChange)="uploadVideo($event, 'after_job')"
        [showTextLink]="true"
        [textLinkClass]="'white-link'" />
    </div>
    @if (afterPhotos?.length == 0) {
      <tidy-row class="extra-top-padding">
        <tidy-text
          [helper]="'None Added'" /><span>&nbsp;</span>
        <tidy-text
          [helper]="beforeAfterState.after" />
      </tidy-row>
    }
    <ion-row>
      @for (item of afterPhotos; track item; let i = $index) {
        <ion-col [size]="12">
          @if (item.mediaType === 'video') {
            <tidy-row>
              <tidy-video
                class="before-after-video"
                [src]="item?.url"
                style="width: 100%; height: auto; max-width: 100%;" />
            </tidy-row>
          }
          @if (item.mediaType === 'photo') {
            @if (item?.url) {
              <tidy-photo-note
                class="full-width no-margin photo-note-job"
                [src]="item?.url"
                style="width: 100%; height: auto; max-width: 100%;" />
            }
          }
          @if (item?.metadata || item?.uploaded_by_id) {
            <div class="timestamp-caption">
              <tidy-row [alignLastItemRight]="true">
                <tidy-text
                  [smallBody]="('Uploaded By:' | translate) + (item?.uploaded_by_type == 'CustomerMember' ? (' You' | translate) : ('Pro' | translate))"
                  class="white" /><span>&nbsp;</span>
                <tidy-text
                  [smallBody]="(item?.uploaded_by_type == 'CustomerMember' ? (' You' | translate) : ('Pro' | translate))"
                  class="white" />
                <div>
                  <tidy-image
                    [src]="'assets/img/trash-outline-white.svg'"
                    (action)="removePhoto(item, i, 'after_job')"
                    class="body-size"
                    style="cursor: pointer" />
                </div>
              </tidy-row>
              @if (item?.metadata?.location) {
                <tidy-row>
                  <tidy-text
                    [smallBody]="('Location:' | translate) + item?.metadata?.location"
                    class="white" /><span>&nbsp;</span>
                  <tidy-text
                    [smallBody]="item?.metadata?.location"
                    class="white" />
                </tidy-row>
              }
              @if (item?.metadata?.displayDate) {
                <tidy-row>
                  <tidy-text
                    [smallBody]="'Timestamp:'"
                    class="white" /><span>&nbsp;</span>
                  <tidy-text
                    [smallBody]="(item?.metadata?.displayDate | parseDateTime: 'ddd MMM d') + ' ' + (item?.metadata?.displayDate | parseDateTime: 'h:mma')"
                    class="white" />
                </tidy-row>
              }
            </div>
          }
        </ion-col>
      }
    </ion-row>
  </tidy-card>
}
